module.exports = __webpack_public_path__ + "img/tabbar4.cca1e988.svg";